<template>
  <div class="text-center">
    <v-dialog v-model="show" width="500" persistent>
      <v-toolbar dark color="primary">
        <v-toolbar-title>Reservation</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card>
        <v-card-title class="text-h5">
          {{ title }}
        </v-card-title>
        <v-card-text> <slot></slot></v-card-text>

        <v-divider></v-divider>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    closeText: {
      type: String,
      default: '',
    },
  },
}
</script>
